import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { BaseTransformer } from './BaseTransformer';
export var GroupTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(GroupTransformer, _BaseTransformer);
  var _super = _createSuper(GroupTransformer);
  function GroupTransformer() {
    _classCallCheck(this, GroupTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(GroupTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        label: data.title,
        value: data.id,
        description: data.description,
        users: data.users ? data.users.split(',') : []
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {};
    }
  }]);
  return GroupTransformer;
}(BaseTransformer);